import { render, staticRenderFns } from "./scene2.vue?vue&type=template&id=7d20ee5c&scoped=true&"
import script from "./scene2.vue?vue&type=script&lang=ts&"
export * from "./scene2.vue?vue&type=script&lang=ts&"
import style0 from "./scene2.vue?vue&type=style&index=0&id=7d20ee5c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d20ee5c",
  null
  
)

export default component.exports